import * as React from "react";
import {Link} from 'react-router-dom';

import "./button.css";

export default function Button ({href, label, colorType}) {
    return (
        <Link className={`button ${colorType}`} to={href}>{label}</Link>
    );
}